/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";
import { useLocation } from "react-router-dom";

import Result from "src/views/report/Result.react";

/**
 * The PrintResult component
 *
 * @author Thais Watanabe
 */
const PrintResult = (props) => {
  const location = useLocation();

  const {
    inspection,
    turbineInspection,
    lastTurbineInspections,
    inspectionModels,
  } = props?.inspection ? props : location.state;

  return (
    <div>
      {inspectionModels &&
        inspectionModels.map((model, i) => (
          <Result
            key={i}
            inspection={inspection}
            inspectionModel={model}
            turbineInspection={turbineInspection}
            lastTurbineInspections={lastTurbineInspections}
            print={true}
          />
        ))}
    </div>
  );
};

export default PrintResult;
